import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Map } from 'immutable';
import { isEmpty } from 'lodash';
import { TiLocationOutline } from 'react-icons/ti';
import styles from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
  showFullAddress: PropTypes.bool,
  disableLink: PropTypes.bool,
};

function FullAddress({ address }) {
  return <div className={styles.fullAddress}>{address.map(a => <div>{a}</div>)}</div>;
}

FullAddress.propTypes = {
  address: PropTypes.object,
};

function Location({
  event,
  className = '',
  showFullAddress,
  disableLink = false,
  withIcon = false,
}) {
  if (isEmpty(event.get('venue'))) {
    return <span />;
  }
  const latitude = event.getIn(['venue', 'address', 'latitude']);
  const longitude = event.getIn(['venue', 'address', 'longitude']);
  const fullArea = event.getIn(['venue', 'address', 'localized_multi_line_address_display']);
  const name = event.getIn(['venue', 'name']);
  const address = showFullAddress ? <FullAddress address={fullArea} /> : name;
  if (withIcon) {
    return (
      <div style={{ display: 'flex', marginRight: 10 }}>
        <TiLocationOutline size={25} style={{ marginRight: 5 }} />
        <div className="location">{address}</div>
      </div>
    );
  }
  return (
    <div
      onClick={() =>
        !disableLink &&
        Wix.openPopup(
          `https://maps.google.com/?q=${latitude},${longitude}&zoom=10&output=embed`,
          500,
          500
        )}
      className={cn('location', className, styles.location)}
    >
      {address}
    </div>
  );
}

Location.propTypes = propTypes;

export default Location;



// WEBPACK FOOTER //
// ./src/widget/event_components/location.js